import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetOrderById(orderId: string | undefined | null) {
  return useQuery(queries.patientsTherapies.getOrderById(orderId || ''))
}
